import React from 'react';

import DeleteIcon from "@mui/icons-material/Delete";
import { Grid, IconButton, Typography } from '@mui/material';

import { CameraIcon } from '../../utils/iconRefs/recipeRatingIcons';
import { resizeImageIfCloudinary } from '../../utils/images/cloudinaryUtils';
import styles from "./UserCommentEdit.module.css";

const UserCommentEdit = ({ userComment, setUserComment, recipeImages, handleImageChange, handleDeleteImage, disabledEditing }: {
    userComment: string,
    setUserComment: React.Dispatch<React.SetStateAction<string>>,
    recipeImages: string[],
    handleImageChange: (e: React.ChangeEvent<HTMLInputElement>) => void,
    handleDeleteImage: (url: string) => void,
    disabledEditing: boolean,
}) => (
    <Grid className={styles.mainContainer} item xs={12}>
        <Typography variant="caption3Bold">
            Your review
        </Typography>
        <textarea
            className={styles.input_textarea}
            defaultValue={userComment ?? undefined}
            disabled={disabledEditing}
            id="user-input"
            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setUserComment(e.target.value)}
            placeholder="Type here to add your comments"
        />
        <Grid
            container
            item spacing={2}
            xs={12}
        >
            {recipeImages?.map((img, index: number) => {
                const compressedImage = resizeImageIfCloudinary(img, 150, 150, -1, -1, true);
                return <Grid item key={compressedImage} xs={4}>
                    <Grid className={styles.imageBox}>
                        <img alt={`uploaded-img-${index}`} className={styles.previewImage} src={compressedImage} />
                        <IconButton
                            aria-label="delete"
                            className={styles.deleteButton}
                            disabled={disabledEditing}
                            onClick={() => handleDeleteImage(img)}
                        >
                            <DeleteIcon />
                        </IconButton>
                    </Grid>
                </Grid>
            })}

            {recipeImages.length < 3 && (
                <Grid item xs={5}>
                    <label className={styles.uploadBox} htmlFor="icon-button-file">
                        <input
                            accept="image/*"
                            disabled={disabledEditing}
                            id="icon-button-file"
                            onChange={handleImageChange}
                            style={{ display: "none" }}
                            type="file"
                        />
                        <CameraIcon />
                        <Typography color="#6D7699" variant="ingredientText2mini">Add photo</Typography>
                    </label>
                </Grid>
            )}
        </Grid>
    </Grid>
);

export default UserCommentEdit;